export { FolderMinus as default } from './FolderMinus';
